import { Component, OnInit } from '@angular/core';
import { ServiceStock } from 'src/app/service-stock.service';
import { MarketWatchHeader } from '../gotx-market-watch/MarketWatchHeader.model';

@Component({
  selector: 'app-gotx-market-watch-edit-column',
  templateUrl: './gotx-market-watch-edit-column.component.html',
  styleUrls: ['./gotx-market-watch-edit-column.component.css']
})
export class GotxMarketWatchEditColumnComponent implements OnInit {

  constructor(private services: ServiceStock, public marketWatchHeader: MarketWatchHeader) { }

  ngOnInit() {
    // setTimeout(() => {
    //   this.marketWatchHeader.header.splice(1, 0, this.marketWatchHeader.header.splice(3, 1)[0]);
    // }, 3000);
  }

  checkSelected() {
    let headers = this.marketWatchHeader.header.filter(el => el.isHidden === true);

    if (headers.length > 0)
      return false;
    else
      return true;
  }

  selectAll(event) {
    this.marketWatchHeader.header.forEach(el => el.isHidden = !event.target.checked);
    if (!event.target.checked)
      this.marketWatchHeader.header[2].isHidden = false;
  }

  updateColumn(event, idx) {
    this.marketWatchHeader.header[idx].isHidden = !event.target.checked;
  }
}
